<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'DividendSetting'
};
</script>

<style></style>
